<template>
    <div>
      <national-trademark-form  ref="nationalTrademarkForm"></national-trademark-form>
      <context-menu ref="copyMenu"></context-menu>
      <b-modal id="trademarkTransactionReportDetailModal" centered size="xl" no-close-on-backdrop ref="trademarkTransactionReportDetailModal" :title=" $t('nationalTrademarkTransactionReportDetail.title')" hide-footer>
        <b-row>
          <b-col class="col-11">
          </b-col>
            <b-col class="col-1">
              <div class="d-flex align-items-right">
              <b-button class="d-inline-block mr-05" size="sm" variant="outline-primary" @click="exportExcel()">{{ $t('excel.excel') }}</b-button>
            </div>
          </b-col>
        </b-row>
    <br/>
      <div class="custom-search">
  
        <!--Row 1-->
        <b-row>
          <b-col>            
            <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('recordNo', $event.target.checked)">
              {{ $t('nationalTrademarkTransactionReportDetail.record_no') }}
            </b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('name', $event.target.checked)">
              {{ $t('nationalTrademarkTransactionReportDetail.name') }}
            </b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('agent', $event.target.checked)">
              {{ $t('nationalTrademarkTransactionReportDetail.agent') }}
            </b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('owner', $event.target.checked)">
              {{ $t('nationalTrademarkTransactionReportDetail.owner') }}
            </b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('applicationNo', $event.target.checked)">
              {{ $t('nationalTrademarkTransactionReportDetail.application_no') }}
            </b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox name="checkbox" @change.native="changeColumns('applicationDate', $event.target.checked)">
              {{ $t('nationalTrademarkTransactionReportDetail.application_date') }}
            </b-form-checkbox>
          </b-col>
        </b-row>
        <!--Row 2-->
      <b-row>
        <b-col>
          <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('registerNo', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.register_no') }}
          </b-form-checkbox>
        </b-col>
        <b-col>
          <b-form-checkbox name="checkbox" @change.native="changeColumns('registerDate', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.register_date') }}
          </b-form-checkbox>
        </b-col>  
        <b-col>
          <b-form-checkbox  name="checkbox" @change.native="changeColumns('firstRegisterNo', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.first_register_no') }}
          </b-form-checkbox>
        </b-col>
        <b-col>
          <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('trademarkTransactionReportDetail.nice_class', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.trademark_nice_class') }}
          </b-form-checkbox>
        </b-col>  
        <b-col>
          <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('trademarkStatus', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.trademark_status') }}
          </b-form-checkbox>
        </b-col>  
        <b-col>
          <b-form-checkbox  name="checkbox" @change.native="changeColumns('note', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.note') }}
          </b-form-checkbox>
        </b-col>
      </b-row>
  
      <!--Row 3-->
      <b-row>
        <b-col>
          <b-form-checkbox  name="checkbox" @change.native="changeColumns('trademarkRenewal.nextRenewalDate', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.next_renewal_date') }}
          </b-form-checkbox>
        </b-col>
        <b-col>
          <b-form-checkbox  name="checkbox" @change.native="changeColumns('trademarkRenewal.renewalDate', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.renewal_date') }}
          </b-form-checkbox>
        </b-col>  
        <b-col>
          <b-form-checkbox  name="checkbox" @change.native="changeColumns('priorityDate', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.priority_date') }}
          </b-form-checkbox>
        </b-col>
        <b-col>
          <b-form-checkbox  name="checkbox" @change.native="changeColumns('instructionDate', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.instruction_date') }}
          </b-form-checkbox>
        </b-col>  
        <b-col>
          <b-form-checkbox  name="checkbox" @change.native="changeColumns('trademarkTransactionReportDetail.nice_class_goods_en', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.nice_class_goods_en') }}
          </b-form-checkbox>
        </b-col>  
        <b-col>
          <b-form-checkbox  name="checkbox" @change.native="changeColumns('trademarkNiceClass.nice_class_goods', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.nice_class_goods') }}
          </b-form-checkbox>
        </b-col>
      </b-row>
  
      <!--Row 4-->
      <b-row>
        <b-col>
          <b-form-checkbox  name="checkbox" @change.native="changeColumns('agentAddress.country', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.agent_address_country') }}
          </b-form-checkbox>
        </b-col>
        <b-col>
          <b-form-checkbox  name="checkbox" @change.native="changeColumns('agentAddress.countryCode', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.agent_address_country_code') }}
          </b-form-checkbox>
        </b-col>  
        <b-col>
          <b-form-checkbox  name="checkbox" @change.native="changeColumns('agentAddress.address', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.agent_address_address') }}
          </b-form-checkbox>
        </b-col>
        <b-col>
          <b-form-checkbox  name="checkbox" @change.native="changeColumns('ownerAddress.country', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.agent_address_country') }}
          </b-form-checkbox>
        </b-col>  
        <b-col>
          <b-form-checkbox  name="checkbox" @change.native="changeColumns('ownerAddress.countryCode', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.owner_address_country_code') }}
          </b-form-checkbox>
        </b-col>  
        <b-col>
          <b-form-checkbox  name="checkbox" @change.native="changeColumns('ownerAddress.address', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.owner_address_address') }}
          </b-form-checkbox>
        </b-col>
      </b-row>
  
      <!--Row 5-->
      <b-row>
        <b-col>
          <b-form-checkbox  name="checkbox" @change.native="changeColumns('agentReferenceNo', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.agent_reference_no') }}
          </b-form-checkbox>
        </b-col>
        <b-col>
          <b-form-checkbox  name="checkbox" @change.native="changeColumns('agentResponsible.name', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.agent_responsible_name') }}
          </b-form-checkbox>
        </b-col>  
        <b-col>
          <b-form-checkbox  name="checkbox" @change.native="changeColumns('agentResponsible.email', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.agent_responsible_email') }}
          </b-form-checkbox>
        </b-col>
        <b-col>
          <b-form-checkbox  name="checkbox" @change.native="changeColumns('renewalAgent', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.renewal_agent') }}
          </b-form-checkbox>
        </b-col>  
        <b-col>
          <b-form-checkbox  name="checkbox" @change.native="changeColumns('renewalAgentResponsible.name', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.renewal_agent_responsible_name') }}
          </b-form-checkbox>
        </b-col>  
        <b-col>
          <b-form-checkbox  name="checkbox" @change.native="changeColumns('renewalAgentResponsible.email', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.renewal_agent_responsible_email') }}
          </b-form-checkbox>
        </b-col>
      </b-row>
  
      <!--Row 6-->
      <b-row>
        <b-col>
          <b-form-checkbox  name="checkbox" @change.native="changeColumns('bulletinDate', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.bulletin_date') }}
          </b-form-checkbox>
        </b-col>
        <b-col>
          <b-form-checkbox  name="checkbox" @change.native="changeColumns('yiDKDate', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.yidk_date') }}
          </b-form-checkbox>
        </b-col>  
        <b-col>
          <b-form-checkbox  name="checkbox" @change.native="changeColumns('ownerNote', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.owner_note') }}
          </b-form-checkbox>
        </b-col>
        <b-col>
          <b-form-checkbox  name="checkbox" @change.native="changeColumns('agentNote', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.agent_note') }}
          </b-form-checkbox>
        </b-col>  
        <b-col>
          <b-form-checkbox name="checkbox" @change.native="changeColumns('invoiceNote', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.invoice_note') }}
          </b-form-checkbox>
        </b-col>  
        <b-col>
          <div class="d-flex align-items-right">
            <b-form-checkbox name="checkbox" @change.native="changeColumns('isTakeOver', $event.target.checked)">
            {{ $t('nationalTrademarkTransactionReportDetail.is_take_over') }}
          </b-form-checkbox>
          </div>
        </b-col>
      </b-row>
    
    </div>
        
        <!-- table -->
      <vue-good-table
        id="trademarkTransactionReportDetailTable"
        ref="trademarkTransactionReportDetailTable" 
        :columns="columns"
        :rows="rows"
        styleClass="vgt-table condensed tableSize"
        :select-options="{
            enabled: false,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
            selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
          }" 
        :search-options="{
          enabled: true,
          externalQuery: searchTerm }"
        :pagination-options="{
          enabled: true,
          perPage:pageLength
        }"
      >
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
  
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'recordNo'">
                <b-row >
                    <b-col class="font-size: x-small">  
                      <b-badge @contextmenu.prevent="openContextMenu($event, props.row.recordNo)" @click="showTrademarkInfoForm(props.row)" variant="primary" style="cursor: pointer;">
                        <feather-icon icon="MousePointerIcon" class="mr-25" />
                        <span>{{ props.row.recordNo }}</span>
                      </b-badge>                     
                    </b-col>
                </b-row>
            </span>
          </template>
     <!-- pagination -->
     <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ props.total }} {{ $t('dataTable.record') }}
            </span>
            <b-form-select v-model="pageLength" :options="['10', '50', '100', '1000']" class="mx-1"
              @input="(value) => props.perPageChanged({ currentPerPage: value })" />
            <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
          </div>
          <div>
            <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number
              align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
      </vue-good-table>
    </b-modal>
    </div>
  </template>
  
  <script>
  
  export default {
    data() {
      return {
        total: 0,
        pageLength: 50,
        dir: false,
        pageNo: 1,
        columns: [],
        rows: [],
        searchTerm: '',
        isAgent:false,
        isOwner:false,
        name:''
      }
    },
    methods: {
      openContextMenu(event, row) {
            this.$refs.copyMenu.openContextMenu(event, row)
        },
      changeColumns(fieldName, status){
        if(status)
        {
          if(fieldName.indexOf("Date") > -1){
            var item = {
              label: this.$t('nationalTrademarkTransactionReportDetail.XXX'.replace("XXX", fieldName.replace(".", "_"))),
              field: fieldName,
              formatFn: this.$formatFn
            }
          this.columns.push(item);
          }
          else{
            var item = {
              label: this.$t('nationalTrademarkTransactionReportDetail.XXX'.replace("XXX", fieldName.replace(".", "_"))),
              field: fieldName,
            }
          this.columns.push(item);
          }
  
        }
        else
        {
          const index = this.columns.findIndex(i => i.field === fieldName)
          this.columns.splice(index, 1);
        }
      },
      showTrademarkInfoForm(row){
        
          this.$refs.nationalTrademarkForm.showInfo(row.id)
      },
      showData(data) {
        this.$refs.trademarkTransactionReportDetailModal.show()
        this.columns = [
          {
            label: this.$t('nationalTrademarkTransactionReportDetail.record_no'),
            field: 'recordNo',
          },
          {
            label: this.$t('nationalTrademarkTransactionReportDetail.name'),
            field: 'name',
          },
          {
            label: this.$t('nationalTrademarkTransactionReportDetail.agent'),
            field: 'agent',
          },          
          {
            label: this.$t('nationalTrademarkTransactionReportDetail.owner'),
            field: 'owner',
          },
          {
            label: this.$t('nationalTrademarkTransactionReportDetail.application_no'),
            field: 'applicationNo',
          },
          {
            label: this.$t('nationalTrademarkTransactionReportDetail.register_no'),
            field: 'registerNo',
          },
          {
            label: this.$t('nationalTrademarkTransactionReportDetail.nice_class'),
            field: 'trademarkNiceClass.nice_class',
          },
          {
            label: this.$t('nationalTrademarkTransactionReportDetail.trademark_status'),
            field: 'trademarkStatus',
          }
        ]
        this.$refs.trademarkTransactionReportDetailModal.show()
        this.rows = data
      },
      exportExcel() {
        var controller = {
            name: 'Trademark',
            actionName: 'CanExport'
        }
  
        var data = {
            columnList: this.columns,
            dataList: this.rows
        }
        var payload = {
            data: data,
            controller: controller
        }
        let loader = this.$loading.show()
        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
            if (response.data.resultStatus == true) {
                this.$downloadFile("Marka Listesi", response.data.base64, 'xlsx')
            } else {
                this.$WarningAlert(response.data.resultMessage)
            }
            loader.hide()
        })
      }      
    },
  }
  </script>
  <style>
   .tableSize {
    font-size: 13px!important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
  }
  </style>
  